import type { Currency } from 'pixai-contract/payment/const'
import type { ExtraPackage } from '../api/types'

function sortByPrice(currency: Currency) {
  return (a: ExtraPackage, b: ExtraPackage) =>
    (a.prices[currency] ?? 0) - (b.prices[currency] ?? 0)
}

export interface ClassifiedPacks {
  oneTime: ExtraPackage[]
  monthly: ExtraPackage[]
  regular: ExtraPackage[]
}

/**
 * Bucket extra packages by purchase flag.
 *
 *   one-time pack  → oneTimePurchase = true (regardless of monthly)
 *   monthly pack   → monthlyPurchase = true && oneTimePurchase = false
 *   regular pack   → both flags false
 *
 * Within each bucket, sorted by price ascending so cheaper packs come
 * first — matches the storefront convention.
 */
export function classifyPacks(
  packages: ExtraPackage[],
  currency: Currency,
  options: { hideOneTimePurchase?: boolean } = {},
): ClassifiedPacks {
  const sort = sortByPrice(currency)
  return {
    oneTime: options.hideOneTimePurchase
      ? []
      : packages.filter(p => p.oneTimePurchase).sort(sort),
    monthly: packages
      .filter(p => p.monthlyPurchase && !p.oneTimePurchase)
      .sort(sort),
    regular: packages
      .filter(p => !p.oneTimePurchase && !p.monthlyPurchase)
      .sort(sort),
  }
}
